import { Children } from 'react';
import chevronRight from '~/assets/icons/nav-chevron-right.svg';

/**
 * A labelled group of navigation rows, each showing a summary of its current
 * value and a chevron, e.g. for drilling into SlidingPanelPages.
 *
 * <NavList label="Customize">
 *     <NavListItem label="Inputs" detail="Rounded" onClick={...} />
 *     <NavListItem label="Color" detail={<NavListSwatch color="#0061fd" />} onClick={...} />
 * </NavList>
 */
export const NavList = ({ label, children, className = '' }) => {
	const items = Children.toArray(children).filter(Boolean);

	return (
		<div className={className}>
			{!!label && (
				<div className="panel-label font-semibold">
					{label}
				</div>
			)}
			<div className="panel max-w-none">
				{items.map((item, idx) => (
					<div
						key={item.key ?? idx}
						className={idx !== items.length - 1 ? 'nav-list-divider' : ''}
					>
						{item}
					</div>
				))}
			</div>
		</div>
	);
};

export const NavListItem = ({ label, detail, onClick }) => {
	return (
		<button
			type="button"
			className="group w-full flex items-start pl-4 text-left"
			onClick={onClick}
		>
			<div className="flex-1 min-w-0 flex items-center justify-between gap-x-8 py-4 pr-3 border-gray-200 [.nav-list-divider_&]:border-b">
				<div className="text-[17px] text-gray-700 shrink-0">
					{label}
				</div>
				<div className="flex items-center justify-end gap-x-3 min-w-0">
					{typeof detail === 'string' ? (
						<div
							className="text-sm leading-5 text-gray-500 truncate"
							title={detail}
						>
							{detail}
						</div>
					) : (
						detail
					)}
					<img src={chevronRight} alt="" className="shrink-0" />
				</div>
			</div>
		</button>
	);
};

export const NavListSwatch = ({ color }) => {
	return (
		<div
			className="w-5 h-5 rounded-full shrink-0"
			style={{ backgroundColor: color }}
		/>
	);
};

export default NavList;
